import { forwardRef, type ForwardedRef } from "react";
import BaseSelect, {
  type GroupBase,
  type Props,
  type SelectInstance,
} from "react-select";
import BaseAsyncSelect, { type AsyncProps } from "react-select/async";
import BaseCreatableSelect, {
  type CreatableProps,
} from "react-select/creatable";
import { SELECT_CLASS_NAMES } from "@/components/Selects/select-class-names";

// Preserve React Select's generic option types and imperative focus refs while
// providing the same defaults for standard, async, and creatable controls.
export const Select = forwardRef(function Select<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  { classNames, ...props }: Props<Option, IsMulti, Group>,
  ref: ForwardedRef<SelectInstance<Option, IsMulti, Group>>,
) {
  return (
    <BaseSelect
      {...props}
      ref={ref}
      classNames={{ ...SELECT_CLASS_NAMES, ...classNames }}
    />
  );
}) as typeof BaseSelect;

export const AsyncSelect = forwardRef(function AsyncSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  { classNames, ...props }: AsyncProps<Option, IsMulti, Group>,
  ref: ForwardedRef<SelectInstance<Option, IsMulti, Group>>,
) {
  return (
    <BaseAsyncSelect
      {...props}
      ref={ref}
      classNames={{ ...SELECT_CLASS_NAMES, ...classNames }}
    />
  );
}) as typeof BaseAsyncSelect;

export const CreatableSelect = forwardRef(function CreatableSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  { classNames, ...props }: CreatableProps<Option, IsMulti, Group>,
  ref: ForwardedRef<SelectInstance<Option, IsMulti, Group>>,
) {
  return (
    <BaseCreatableSelect
      {...props}
      ref={ref}
      classNames={{ ...SELECT_CLASS_NAMES, ...classNames }}
    />
  );
}) as typeof BaseCreatableSelect;
